import React, { useState } from "react";
import { Badge, Button, Popover, Select, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FieldTimeOutlined, ShoppingCartOutlined, UserOutlined } from "@ant-design/icons";

import { Menu } from "antd";
import Search from "./Search/Search";


import SelectLanguage from "./SelectLanguage";
import useChangeRelation from '../../components/changeRelation/useChangeRelation';

import { t } from "i18next";
// import MobileHeader from "../Mobile/MobileHeader";

import { toggle } from "@/store/basket";
import HeaderIcons from "./HeaderIcons";

import { useWindowDimensions } from '@/hooks/useWindowDimensions';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const MobileHeader = () => <></>

const LogoMap = ({ Color = "white" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={15} height={22} viewBox="0 0 15 22" fill="none"  >
    <g clipPath="url(#a)" stroke={Color} strokeLinecap="round" strokeLinejoin="round"    >
      <path clipRule="evenodd" d="M13.853 9.545c0 5.091-6.427 9.455-6.427 9.455S1 14.636 1 9.545c0-1.736.677-3.4 1.882-4.628A6.368 6.368 0 0 1 7.426 3c1.705 0 3.34.69 4.545 1.917a6.607 6.607 0 0 1 1.882 4.628Z" />
      <path d="M7.427 11.727c1.183 0 2.142-.977 2.142-2.182s-.96-2.181-2.142-2.181c-1.183 0-2.143.976-2.143 2.181s.96 2.182 2.143 2.182Z" />
    </g>
    <defs><clipPath id="a"><path fill={Color} d="M0 0h14.853v22H0z" /></clipPath></defs>
  </svg>
);

const LogoPhone = ({ Color = "white" }) => (
  // <svg width={21} height={21} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  //   <path
  //     d="M19.9923 3.31802L17.3091 0.637409C16.9816 0.309891 16.5432 0.125977 16.0797 0.125977C15.6161 0.125977 15.1777 0.307371 14.8502 0.637409L11.9605 3.52209C11.633 3.84961 11.4491 4.2905 11.4491 4.75406C11.4491 5.22014 11.6305 5.65599 11.9605 5.98603L14.2179 8.24591C13.7036 9.44408 12.9647 10.5327 12.0411 11.4531C11.1165 12.3827 10.0357 13.1158 8.83648 13.6348L6.57913 11.375C6.25161 11.0474 5.81324 10.8635 5.34967 10.8635C5.12102 10.8627 4.89451 10.9075 4.68339 10.9953C4.47228 11.0831 4.28081 11.2122 4.12022 11.375L1.22798 14.2596C0.900467 14.5872 0.716553 15.0281 0.716553 15.4916C0.716553 15.9577 0.897947 16.3935 1.22798 16.7236L3.90859 19.4042C4.46789 19.9635 5.23882 20.2835 6.0299 20.2835C6.19366 20.2835 6.35238 20.2709 6.51362 20.2431C9.84927 19.6939 13.1597 17.9178 15.8328 15.2472C18.5033 12.5717 20.2769 9.26121 20.8312 5.92305C20.9899 4.97576 20.6725 4.00077 19.9923 3.31802ZM19.045 5.62324C18.5537 8.59358 16.9564 11.5564 14.5504 13.9624C12.1444 16.3684 9.18416 17.9656 6.21382 18.4569C5.84095 18.5199 5.45801 18.3939 5.18591 18.1244L2.55317 15.4916L5.34464 12.6976L8.36284 15.7209L8.38552 15.7436L8.9297 15.542C10.5797 14.9354 12.0781 13.9772 13.3209 12.7339C14.5638 11.4906 15.5215 9.99186 16.1275 8.34164L16.3291 7.79746L13.2857 4.75658L16.0772 1.9626L18.7099 4.59534C18.982 4.86743 19.108 5.25038 19.045 5.62324Z"
  //     fill={Color}
  //   />
  // </svg>
  <svg width={17} height={17} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"   >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.373 11.4597C6.21519 16.7719 3.717 15.9757 2.89846 15.3986C2.76696 15.3241 0.000711844 13.4944 1.49788 11.5893C5.23445 6.8608 5.34134 12.7092 8.77976 8.9412C12.2182 5.17314 6.5955 5.45887 11.2104 1.5847C13.0711 0.0317744 14.9818 2.74274 15.0592 2.87114C15.6612 3.6723 16.5309 6.14678 11.373 11.4597Z"
      stroke={Color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CurrencyIcon = ({ Color = "white" }) => (
  <svg width={23} height={23} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3381 10.2976C10.5441 9.70299 9.67733 9.33007 9.67733 8.38267C9.67733 7.35464 10.7961 6.98173 11.5016 6.98173C12.8219 6.98173 13.3057 7.97952 13.4165 8.33228L15.009 7.657C14.8578 7.20346 14.1825 5.72188 12.449 5.39936V4.1496H10.4332V5.41952C7.9337 5.98393 7.92363 8.30204 7.92363 8.40283C7.92363 10.6907 10.1913 11.3357 11.3 11.7389C12.8924 12.3033 13.598 12.8173 13.598 13.7849C13.598 14.9238 12.5397 15.4076 11.6024 15.4076C9.76803 15.4076 9.24394 13.5228 9.18347 13.3011L7.5104 13.9764C8.14536 16.1836 9.80835 16.7783 10.4332 16.9597V18.2598H12.449V17.0101C12.8521 16.9194 15.3718 16.4154 15.3718 13.7647C15.3718 12.3638 14.757 11.1342 12.3381 10.2976ZM2.37024 20.2756H0.354492V14.2283H6.40174V16.2441H3.90221C5.52489 18.6731 8.29654 20.2756 11.4411 20.2756C13.8468 20.2756 16.1541 19.3199 17.8552 17.6188C19.5563 15.9177 20.512 13.6105 20.512 11.2047H22.5277C22.5277 17.3326 17.569 22.2913 11.4411 22.2913C7.69181 22.2913 4.37591 20.4268 2.37024 17.5846V20.2756ZM0.354492 11.2047C0.354492 5.07684 5.31323 0.118103 11.4411 0.118103C15.1904 0.118103 18.5063 1.98267 20.512 4.82487V2.13385H22.5277V8.1811H16.4805V6.16535H18.98C17.3573 3.73637 14.5857 2.13385 11.4411 2.13385C9.03536 2.13385 6.72815 3.08953 5.02704 4.79065C3.32592 6.49176 2.37024 8.79897 2.37024 11.2047H0.354492Z"
      fill={Color}
    />
  </svg>
);


const WorldIcon = ({ Color = "white" }) => (
  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.23633 11.2047C1.23633 16.771 5.74873 21.2835 11.3151 21.2835C16.8814 21.2835 21.3938 16.771 21.3938 11.2047C21.3938 5.63838 16.8814 1.12598 11.3151 1.12598C5.74873 1.12598 1.23633 5.63838 1.23633 11.2047Z"
      stroke={Color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12.323 1.17566C12.323 1.17566 15.3466 5.15739 15.3466 11.2046C15.3466 17.2518 12.323 21.2336 12.323 21.2336" stroke={Color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.3073 21.2336C10.3073 21.2336 7.28369 17.2518 7.28369 11.2046C7.28369 5.15739 10.3073 1.17566 10.3073 1.17566" stroke={Color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.87109 14.7323H20.7594" stroke={Color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.87109 7.67719H20.7594" stroke={Color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);


const HistoryIcon = ({ Color, Width = 45, Height = 47 }) => (
  <svg width={Width} height={Height} viewBox="0 -15 43 58" fill="none" xmlns="http://www.w3.org/2000/svg">

    <path d="M31.0443 30.7592C25.2239 35.9412 16.3048 35.4236 11.1229 29.6033C5.94101 23.7829 6.45856 14.8638 12.2789 9.68188" stroke={Color} strokeWidth="4" strokeLinecap="round" />
    <path d="M11.123 29.6033C5.94103 23.7829 6.45859 14.8638 12.2789 9.68189C18.0993 4.49997 27.0184 5.01752 32.2003 10.8379" stroke={Color} strokeWidth="4" />
    <line x1="32.9685" y1="5.32282" x2="32.9685" y2="12.4094" stroke={Color} strokeWidth="4" strokeLinecap="round" />
    <line x1="33" y1="12.3779" x2="25.9134" y2="12.3779" stroke={Color} strokeWidth="4" strokeLinecap="round" />
    <line x1="19.3662" y1="14.9016" x2="19.3662" y2="23.996" stroke={Color} strokeWidth="3" strokeLinecap="round" />
    <line x1="19.3662" y1="23.996" x2="23.4213" y2="23.996" stroke={Color} strokeWidth="3" strokeLinecap="round" />
  </svg>
);

const BasketIcon = ({ onClick, Color, Width = 35, Height = 40 }) => (
  <svg onClick={onClick} width={Width} height={Header} viewBox="0 -15 41 53" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M37.3469 6.0884C36.9016 5.93231 36.4301 5.86495 35.959 5.89013H17.9164C17.2224 5.89013 16.3302 5.791 15.6363 5.98927C15.2106 6.08617 14.8308 6.3259 14.5603 6.66858C14.2898 7.01127 14.1447 7.43625 14.1493 7.87283C14.1493 8.39868 14.3581 8.90299 14.73 9.27482C15.1018 9.64665 15.6061 9.85554 16.132 9.85554H34.0754L32.4893 18.1829C32.389 18.6336 32.1377 19.0366 31.7771 19.325C31.4166 19.6135 30.9683 19.7701 30.5065 19.7691H15.6363C15.1786 19.7551 14.7378 19.5929 14.3802 19.3069C14.0226 19.0208 13.7676 18.6264 13.6536 18.1829L10.4813 3.51089C10.2891 2.62355 9.80251 1.82726 9.10063 1.25135C8.39874 0.675448 7.52276 0.353767 6.61498 0.338562H5.22709C4.70124 0.338562 4.19693 0.547453 3.82511 0.919282C3.45328 1.29111 3.24438 1.79542 3.24438 2.32127C3.24438 2.84711 3.45328 3.35142 3.82511 3.72325C4.19693 4.09508 4.70124 4.30397 5.22709 4.30397H6.61498L9.7873 18.976C10.3821 21.7518 12.7614 23.6353 15.6363 23.6353H30.5065C32.8858 23.6353 35.3642 22.0492 36.0581 19.7691C36.5538 18.1829 36.8512 16.3985 37.1486 14.8123C37.446 13.127 37.8425 11.4417 38.14 9.85554C38.2534 9.53634 38.3202 9.20245 38.3382 8.86419C38.4202 8.54047 38.4536 8.20637 38.4374 7.87283C38.4374 7.07975 38.0408 6.28667 37.3469 6.0884ZM11.1752 27.6007C11.1752 28.3895 11.4885 29.146 12.0463 29.7037C12.604 30.2614 13.3605 30.5748 14.1493 30.5748C14.938 30.5748 15.6945 30.2614 16.2522 29.7037C16.81 29.146 17.1233 28.3895 17.1233 27.6007C17.1233 26.812 16.81 26.0555 16.2522 25.4978C15.6945 24.94 14.938 24.6267 14.1493 24.6267C13.3605 24.6267 12.604 24.94 12.0463 25.4978C11.4885 26.0555 11.1752 26.812 11.1752 27.6007ZM29.0195 27.6007C29.0195 28.1889 29.1939 28.7639 29.5207 29.253C29.8475 29.7421 30.312 30.1233 30.8555 30.3484C31.3989 30.5735 31.9969 30.6324 32.5738 30.5176C33.1507 30.4029 33.6806 30.1196 34.0965 29.7037C34.5125 29.2878 34.7957 28.7578 34.9105 28.1809C35.0252 27.604 34.9663 27.006 34.7412 26.4626C34.5161 25.9192 34.135 25.4547 33.6459 25.1279C33.1568 24.8011 32.5818 24.6267 31.9936 24.6267C31.2048 24.6267 30.4483 24.94 29.8906 25.4978C29.3329 26.0555 29.0195 26.812 29.0195 27.6007Z"
      fill={Color}
    />
  </svg>
);

const CompanyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={21}
    viewBox="0 0 18 21"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.412 1.059H3.176c-1.17 0-2.117.948-2.117 2.117v13.765c0 1.17.948 2.118 2.117 2.118H9.53V3.176c0-1.17-.948-2.117-2.117-2.117ZM3.176 20.118h11.647A3.176 3.176 0 0 0 18 16.94V7.41a3.177 3.177 0 0 0-3.177-3.176h-4.235V3.176A3.176 3.176 0 0 0 7.412 0H3.176A3.176 3.176 0 0 0 0 3.176v13.765a3.176 3.176 0 0 0 3.176 3.177Zm11.647-1.06h-4.235V5.295h4.236c1.17 0 2.117.948 2.117 2.118v9.53a2.117 2.117 0 0 1-2.117 2.117ZM3.176 5.295a.53.53 0 1 0 0 1.059h4.236a.53.53 0 1 0 0-1.059H3.176Zm-.529 4.765a.53.53 0 0 1 .53-.53h4.235a.53.53 0 1 1 0 1.06H3.176a.53.53 0 0 1-.529-.53Zm9-.53a.53.53 0 1 0 0 1.06h4.235a.53.53 0 0 0 0-1.06h-4.235Zm-9 4.765a.53.53 0 0 1 .53-.53h4.235a.53.53 0 1 1 0 1.06H3.176a.53.53 0 0 1-.529-.53Zm9-.53a.53.53 0 1 0 0 1.06h4.235a.53.53 0 0 0 0-1.06h-4.235Z"
      fill={props.Color}
    />
  </svg>
);

const RemoveIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={11}
    viewBox="0 0 12 11"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.284.364a1 1 0 1 1 1.414 1.414L6.985 5.49l3.803 3.802a1 1 0 0 1-1.414 1.414L5.57 6.905l-3.8 3.802A1 1 0 1 1 .355 9.293l3.802-3.802L.444 1.778A1 1 0 0 1 1.858.364l3.713 3.713L9.284.364Z"
      fill={props.Color || "#000"}
    />
  </svg>
);

const AccountIcon = ({ Color }) => (
  <svg width={45} height={45} viewBox="0 -15 53 56" fill="none" xmlns="http://www.w3.org/2000/svg">

    <circle cx="25.8662" cy="10.3937" r="8.06299" stroke={Color} strokeWidth={4} />
    <path d="M40.9843 34.5826C40.9843 26.2331 34.2157 19.4645 25.8662 19.4645C17.5167 19.4645 10.748 26.2331 10.748 34.5826" stroke={Color} strokeWidth={4} />
  </svg>
);

const Header = () => {
  const session = useSelector(e => e.session)
  const login = useSelector(e => e.session.login)

  const settings = useSelector(e => e.settings)
  const d = useDispatch();
  const HeaderShowCurrency = settings.HeaderShowCurrency == 'true' ? true : false
  const HeaderShowLanguage = settings.HeaderShowLanguage == 'true' ? true : false
  const basket = useSelector(e => e.basket)
  const { t } = useTranslation()

  const navigate = useNavigate()
  const { width, height } = useWindowDimensions();

  const workingHours = settings.WorkingHours ? settings.WorkingHours : ""

  const changeRelation = useChangeRelation()

  const onClear = () => {
    changeRelation.clear()
    message.success('Relation cleared')
  }


  return (
    <>
      {/* <div style={{ width: '100%', background: settings['HeaderBgColor'] }}>


      </div> */}
      <div className="header3" style={{ width: '100%', background: settings['HeaderBgColor'] }}>
        <div className=" header3__top__container">
          <div className=" header3__top__container__contact">
            <div className=" header3__top__container__contact__item" style={{ paddingRight: "20px" }}>
              <div className=" header3__top__container__contact__item__icon">
                <LogoMap Color={settings['HeaderIconColor']} />
              </div>
              <div style={{ color: settings['HeaderTextColor'] }} className=" header3__top__container__contact__item__text">{settings.Address}</div>
            </div>

            <div className=" header3__top__container__contact__item">
              <div className=" header3__top__container__contact__item__icon">
                <LogoPhone Color={settings['HeaderIconColor']} />
              </div>
              <div style={{ color: settings['HeaderTextColor'] }} className=" header3__top__container__contact__item__text">{settings.Phone}</div>
            </div>
            {/* <div className=" header3__top__container__contact__item">
              <div className=" header3__top__container__contact__item__icon">
                <FieldTimeOutlined style={{
                  fontSize: '24px',
                  color: 'white'
                }} />
              </div>
              <div style={{ color: settings['HeaderTextColor'] }} className=" header3__top__container__contact__item__text">{workingHours}</div>
            </div> */}
          </div>


          <div className=" header3__top__container__right-side">
            {(session?.relationName && session?.relationName != null) &&
              // <div className="flex items-center justify-center">
              //   <div style={{ color: settings['HeaderTextColor'], fontSize: '14px', fontWeight: 'bold' }} className=" header3__top__container__contact__item__text">
              //     <CompanyIcon Color={settings['HeaderIconColor']} />
              //     {`${t('active-relation')} : ${session?.relationName}`}
              //   </div>
              // </div>

              <div className="header3__top__container__right-side__item" style={{ color: settings['HeaderTextColor'], fontSize: '14px', fontWeight: 'bold' }}>
                <div className="header3__top__container__right-side__item__icon">
                  <CompanyIcon Color={settings['HeaderIconColor']} />
                </div>
                <div style={{ color: settings['HeaderTextColor'] }} className=" header3__top__container__contact__item__text">{session?.relationName}</div>

                <div className="header3__top__container__right-side__item__icon ml-[10px] cursor-pointer" onClick={() => onClear()}>
                  <RemoveIcon Color="#fff" />
                </div>

              </div>
            }


            {/* <div onClick={() => d(toggle(true))} className=" header3__top__container__contact__item cursor-pointer "  >
              <div className=" header3__top__container__contact__item__i  con" style={{ paddingBottom: '10px' }}>
                <BasketIcon Width={30} Height={40} Color={settings['HeaderIconColor']} />
              </div>
              <div style={{ color: settings['HeaderTextColor'] }} className=" header3__top__container__contact__item__text">{t('basket')}</div>

            </div>

            <div className=" header3__top__container__contact__item cursor-pointer" onClick={() => navigate('/' + 'history')}  >
              <div className=" header3__top__container__contact__item__i  con" style={{ paddingBottom: '10px' }}>
                <HistoryIcon Width={30} Height={40} Color={settings['HeaderIconColor']} />
              </div>
              <div className=" header3__top__container__contact__item__text">{t('history')}</div>
            </div>

            {HeaderShowCurrency ? <div className=" header3__top__container__right-side__item">
              <div className=" header3__top__container__right-side__item__icon">
                <CurrencyIcon Color={settings['HeaderIconColor']} />
              </div>

              <div className=" header3__top__container__right-side__item__input">
                <select style={{ border: '1px solid ' + settings['HeaderIconColor'] }} placeholder="EURO">
                  <option value="euro">EURO</option>
                </select>
              </div>
            </div> : null} */}
            {HeaderShowLanguage ? <div className=" header3__top__container__right-side__item">
              <div className=" header3__top__container__right-side__item__icon">
                <WorldIcon Color={settings['HeaderIconColor']} />
              </div>
              <SelectLanguage />
            </div> : null}
          </div>
        </div>
        <div className="header3__bottom  ">
          <div className=" header3__bottom__container " style={{ backgroundColor: settings['HeaderBaseBgColor'] }} >
            <div className=" header3__bottom__container__image cursor-pointer ">
              <img style={{ cursor: 'pointer' }} className="cursor-pointer" src={settings['base-logo']} onClick={() => navigate('/')} />

            </div>

            <div className=" header3__bottom__container__search">
              {width >= 1024 ? <Search /> : null}
            </div>

            <div className="header3__bottom__container__right-menu">
              <HeaderIcons />
            </div>
          </div>
        </div>
      </div>
      {width < 1024 ? <MobileHeader /> : null}
    </>
  );
};
export default Header;
